export default __webpack_public_path__ + "static/media/logoAzul.bab51741.webp";